import { render, staticRenderFns } from "./DDTDettaglioView.vue?vue&type=template&id=10ca16a8&"
import script from "./DDTDettaglioView.vue?vue&type=script&lang=js&"
export * from "./DDTDettaglioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports